import { File, LinkSimple, X } from "@phosphor-icons/react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export type TAttachmentKind = "file" | "link";

type TAttachmentItemProps = {
  kind: TAttachmentKind;
  label: string;
  onRemove?: () => void;
  className?: string;
};

export function AttachmentItem({ kind, label, onRemove, className }: TAttachmentItemProps) {
  const Icon = kind === "file" ? File : LinkSimple;
  return (
    <div className={cn("flex w-full items-center gap-[8px]", className)}>
      <div className="flex min-w-0 flex-1 items-center gap-[8px]">
        <Icon size={16} className="shrink-0 text-innoveraZinc-900" />
        <FigmaTypography variant="body-2" color="zinc900" className="truncate">{label}</FigmaTypography>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="flex shrink-0 items-center justify-center text-innoveraZinc-900 hover:text-innoveraZinc-700"
          aria-label={`Remove ${label}`}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
